import React from 'react';
import * as yup from 'yup';
import moment from 'moment';
import Translate from 'react-translate-component';

import { DATE_FORMATS } from 'constants/dateFormats';
import { PASSWORD } from 'constants/regexp';

yup.addMethod(yup.mixed, 'match', function (matchField, message = 'errors.matchDefault') {
    return this.test('match', message, function (value) {
        const matchFieldValue = this.parent[matchField];
        return value === matchFieldValue;
    });
});

yup.addMethod(yup.mixed, 'range', function (min, max, message = 'errors.rangeDefault') {
    return this.test('range', message, function (value) {
        if (value) {
            const valueLength = value.length;
            return (valueLength >= min && valueLength <= max);
        } else {
            return false
        }
    });
});

yup.addMethod(yup.string, 'checkPast', function() {
    return this.test({
        name: 'checkPast',
        exclusive: true,
        message: 'dateInPast',
        test: function(value) {
            return value ? !moment(value, DATE_FORMATS.format).isBefore(moment(), 'day') : true;
        }
    });
});

yup.addMethod(yup.mixed, 'dateIsNowOrBefore', function (message = 'dateIsNowOrBefore') {
    return this.test('dateIsNowOrBefore', message, function (selectedDateString) {
        const nowDateString = new Date().toLocaleDateString('ru');
        return selectedDateString <= nowDateString;
    });
});

yup.addMethod(yup.string, 'checkPasswordSecurity', function(message = 'passwordMustContain') {
    return this.test('checkPasswordSecurity', message, function(value) {
        return value ? PASSWORD.test(value) : true;
    });
});

yup.addMethod(yup.mixed, 'maxLength', function(maxLength) {
    const message = <Translate content={ 'errors.maxTextFieldLength' } with={{ value: maxLength }} />;

    return this.test('maxLength', message, function(value) {
        if (value) {
            return value ? !(String(value).length > maxLength) : true;
        }

        return true;
    });
});
